export const convertImage = (imageData, imageType) => {
    const arrayBufferView = new Uint8Array(imageData);
    
    // Determine the correct MIME type based on the imageType
    let mimeType;
    if (!imageType) {
        mimeType = 'image/png'; // Default to PNG
    } else if (imageType.includes('/')) {
        mimeType = imageType; // Already a MIME type
    } else {
        // Convert extension to MIME type
        switch (imageType.toLowerCase()) {
            case 'jpeg':
            case 'jpg':
                mimeType = 'image/jpeg';
                break;
            case 'webp':
                mimeType = 'image/webp';
                break;
            default:
                mimeType = `image/${imageType}`;
        }
    }
    
    // Create blob with the correct MIME type
    const blob = new Blob([arrayBufferView], { type: mimeType });
    const urlCreator = window.URL || window.webkitURL;
    const url = urlCreator.createObjectURL(blob);
    return { url, blob };
};
